import { createFileRoute } from "@tanstack/react-router";
import { PortfolioPage } from "@/features/executive/PortfolioPage";

export const Route = createFileRoute("/_app/portfolio")({ component: PortfolioPage });
